<template>
    <div class="panorama-table-swiper">
        <div ref="swiper" class="table-swiper">
            <slot></slot>
        </div>
        <div v-if="canSwipeLeft" class="horizontal-navigation-wrapper left" @click="onSwipeLeft">
            <div class="horizontal-navigation left">
                <span></span>
            </div>
        </div>
        <div v-if="canSwipeRight" class="horizontal-navigation-wrapper right" @click="onSwipeRight">
            <div class="horizontal-navigation right">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["refHeaderRow", "refTable"],
    data() {
        return {
            firstVisibleColumnIndex: 0,
            translatedOffset: 0,
            isMounted: false,
            lastOffset: 0,

            swiperWidth: 0,
        };
    },
    created() {
        window.addEventListener("resize", this.resizeHandler.bind(this));
    },
    mounted() {
        this.isMounted = true;
        this.init();
    },
    methods: {
        init() {
            if (!this.isMounted) return;
            this.swiperWidth = this.$refs.swiper.offsetWidth;
            this.firstVisibleColumnIndex = 0;
            this.translatedOffset = 0;
            this.lastOffset = 0;
        },
        onSwipeLeft() {
            if (!this.canSwipeLeft) return;
            const lastVisibleColumnIndex = this.firstVisibleColumnIndex - 1;
            const lastVisibleColumnWidth =
                this.refHeaderRow.children[lastVisibleColumnIndex].offsetWidth;
            const offset = this.calculateOffsetToLeft(lastVisibleColumnWidth);
            this.translate(offset);
            this.firstVisibleColumnIndex = this.firstVisibleColumnIndex - 1;
        },
        onSwipeRight() {
            const firstVisibleColumnWidth =
                this.refHeaderRow.children[this.firstVisibleColumnIndex].offsetWidth;
            const offset = this.calculateOffsetToRight(firstVisibleColumnWidth);
            this.translate(offset);
            this.firstVisibleColumnIndex = this.firstVisibleColumnIndex + 1;
        },
        translate(offset) {
            this.refTable.style.transform = `translateX(-${offset}px)`;
            this.translatedOffset = offset;
        },

        calculateOffsetToLeft(offset) {
            if (this.lastOffset > 0) {
                const lastOffset = this.lastOffset;
                this.lastOffset = 0;
                return this.translatedOffset - lastOffset;
            }

            return this.translatedOffset - offset;
        },

        calculateOffsetToRight(offset) {
            const maxOffset = this.refTable.offsetWidth - this.swiperWidth - this.translatedOffset;
            if (maxOffset < offset) {
                this.lastOffset = maxOffset;
            }
            return this.translatedOffset + Math.min(offset, maxOffset);
        },
        resizeHandler() {
            this.init();
            this.translate(0);
        },
    },
    computed: {
        canSwipeLeft() {
            return this.firstVisibleColumnIndex > 0;
        },
        canSwipeRight() {
            if (!this.isMounted) return false;
            const totalTableWidth = this.refTable.offsetWidth;
            const remainingWidth = totalTableWidth - this.translatedOffset;
            return remainingWidth > this.swiperWidth;
        },
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeHandler.bind(this));
    },
};
</script>

<style scoped lang="sass">
.horizontal-navigation-wrapper
    position: absolute
    top: 0
    bottom: 0
    padding: 300px 0
    &.left
        left: -16px

    &.right
        right: -16px

.horizontal-navigation
    cursor: pointer
    position: sticky
    top: 40%
    background: $color-background
    display: flex
    align-items: center
    justify-content: center
    padding: $grid-gutter $grid-gutter
    span
        width: 20px
        height: 38px
        background-repeat: no-repeat
        background-size: cover
        filter: invert(18%) sepia(0%) saturate(4971%) hue-rotate(223deg) brightness(103%) contrast(103%)
        transition: transform 0.1s ease-in-out

    &.left
        span
            background-image: url(src/assets/images/svg/arrow-left.svg)
        &:hover
            span
                filter: none
                transform: translateX(-3px)

    &.right
        span
            background-image: url(src/assets/images/svg/arrow-right.svg)
        &:hover
            span
                filter: none
                transform: translateX(3px)
</style>
